import SpriteSymbol from "../../../../../../../node_modules/normacs_web/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/normacs_web/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "document--card",
  "use": "document--card-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 64 64\" id=\"document--card\">\n  <path d=\"M43 56V43.15c0-1.188.977-2.15 2.147-2.15H56L43 56zm-29-9h23v4H14v-4zm0-8h23v4H14v-4zm0-12h35v4H14v-4zM8 17v-5.398C8 9.612 9.882 8 12.176 8h39.648C54.13 8 56 9.608 56 11.585V17H8zm0 4v30.88C8 54.145 9.863 56 12.162 56h29.23V43.643c0-2.288 1.874-4.114 4.186-4.114H56V21H8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol